import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import DateRangeIcon from '@material-ui/icons/DateRange';

export default (props) => {
    const url = useSelector(state => state.redirect.url);
    const isHostCancel = useSelector(state => state.redirect.isHostCancel);
    const isAttendeeCancel = useSelector(state => state.redirect.isAttendeeCancel);
    const eventName = useSelector(state => state.redirect.eventName);

    return (
        <div className='page create-schedule'>
            {isAttendeeCancel && (
                <h3 className='page-title'><DateRangeIcon />Your RSVP to {eventName} has been cancelled.</h3>
            )
            }

            {isHostCancel && (
                <h3 className='page-title'><DateRangeIcon />Your event, {eventName}, has been canceled and notification has been sent to attendees.</h3>
            )
            }

        </div>
    )
};